import type { ComponentType } from 'react'
import IconFlagFR from '@/shared/icons/NewDesign/Flags/IconFlagFR'
import IconFlagBE from '@/shared/icons/NewDesign/Flags/IconFlagBE'
import IconFlagIT from '@/shared/icons/NewDesign/Flags/IconFlagIT'
import IconFlagNL from '@/shared/icons/NewDesign/Flags/IconFlagNL'
import IconFlagDE from '@/shared/icons/NewDesign/Flags/IconFlagDE'
import IconFlagAT from '@/shared/icons/NewDesign/Flags/IconFlagAT'

type FlagIcon = ComponentType<{ size?: number }>

type CountryFlagProps = {
  country: string
  size?: number
}

export const flagByCountry: Record<string, FlagIcon> = {
  fr: IconFlagFR,
  be: IconFlagBE,
  it: IconFlagIT,
  nl: IconFlagNL,
  de: IconFlagDE,
  at: IconFlagAT,
}

const CountryFlag = ({ country, size = 24 }: CountryFlagProps) => {
  const Flag = flagByCountry[country]
  if (!Flag) return null

  return <Flag size={size} />
}

export default CountryFlag
